import { SAVEBREADCRUMB } from "../actions";

  export const saveBreadCrumb = (request) => ({
    payload: request,
    type: SAVEBREADCRUMB,
  });